import validateDmnAndQueryBuilder from 'pages/rules/utils/validateDmnAndQueryBuilder';
import updatedValues from 'pages/rules/utils/updatedValues';
import changedKeysFn from 'pages/rules/utils/changedValues';
import parseDmn from 'components/modules/dmn/src/utils/parseDmn';
import constants from 'core/constants/Constants';

export default function validateRule({
  ruleType,
  clawbackTypeValOnSave,
  ruleApplicabilty,
  ruleApplicabilityModeType,
  outputformula,
  outputFormulaModeType,
  state,
  value,
  form,
  userDetails,
  hasApplicabilityView = true,
  hasFormulaView = true,
}) {
  const isClawbackDirect =
    ruleType === 'clawback' &&
    (clawbackTypeValOnSave === 'RECALCULATION' ||
      clawbackTypeValOnSave === 'FULL');
  const isClawback = ruleType === 'clawback';

  if (!isClawbackDirect && !isClawback) {
    const validationResult = validateDmnAndQueryBuilder({
      ruleApplicabilty,
      ruleApplicabilityModeType,
      outputformula,
      outputFormulaModeType,
      state,
      value,
    });
    if (!validationResult.isValid) {
      return {
        isValid: false,
        errorMessage:
          'Please check the Payout Matrix — some values are invalid or missing.',
      };
    }
  }
  const hasRuleApplicability =
    !hasApplicabilityView || !!ruleApplicabilty?.query;
  const hasOutputFormula =
    !hasFormulaView || !!outputformula?.query || !!outputformula?.type;

  if (
    !isClawbackDirect &&
    !isClawback &&
    !value?.enter_amount &&
    (!hasRuleApplicability || !hasOutputFormula)
  ) {
    return {
      isValid: false,
      errorMessage:
        'Please complete "Apply This Rule When" and "Output Formula" before saving.',
    };
  }

  const updatedValue = updatedValues(
    value,
    form.getFieldValue('output_formula'),
    form.getFieldValue('rule_expression'),
    state.configFields,
    state.inputSourceFileData
  );
  const currentValue = { ...value, ...updatedValue };
  const previousDmnData = parseDmn(state.previousXmlValues);
  const changedKeys = changedKeysFn(
    currentValue,
    state.previousValues,
    state.dmnData,
    previousDmnData
  );
  const isCreate = state.pageType === 'Create';

  const ruleValue = {
    ...currentValue,
    rule_visibility: isCreate
      ? userDetails?.user_employee_id
      : value?.rule_visibility,
    rule_type: isCreate ? constants.common : value?.rule_type,
    is_new_dmn_uploaded: isClawbackDirect ? false : changedKeys?.dmnChanged,
  };
  const hiddenKeys = [
    ...(!hasApplicabilityView
      ? [
          'rule_applicability',
          'rule_applicability_json',
          'rule_applicability_mode_type',
          'rule_applicability_editor_type',
        ]
      : []),
    ...(!hasFormulaView
      ? [
          'output_formula',
          'output_formula_json',
          'output_formula_mode_type',
          'output_formula_editor_type',
          'output_formula_type',
        ]
      : []),
  ];
  const safeRuleValue = Object.fromEntries(
    Object.entries(ruleValue).filter(([key]) => !hiddenKeys.includes(key))
  );

  return { isValid: true, ruleValue: safeRuleValue, changedKeys };
}
